module.exports = __webpack_public_path__ + "img/unit_White.fb5970ef.png";